import { jsx } from "react/jsx-runtime";
import { LayoutPage } from "@contember/ui";
import { memo } from "react";
import { getPageName } from "./getPageName.js";
const GenericPage = memo(
  ({ children, ...props }) => /* @__PURE__ */ jsx(LayoutPage, { ...props, children })
);
GenericPage.displayName = "GenericPage";
GenericPage.getPageName = getPageName;
export {
  GenericPage
};
//# sourceMappingURL=GenericPage.js.map
